/* kava 2026 — the brand name is always written "kava", never "Kava" or "KAVA".
   Wraps every occurrence in <span class="kv-lc"> (text-transform: none) so CSS
   uppercase styles from apps or blocks can't capitalise it either. */
(() => {
  const RE = /kava/gi;
  const SKIP = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'CODE', 'PRE', 'SVG']);

  const fix = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || SKIP.has(parent.tagName) || parent.closest('.kv-lc, .kv-lcw, [contenteditable]')) return NodeFilter.FILTER_REJECT;
        RE.lastIndex = 0;
        return RE.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      // One wrapper per text node: inside flex/grid parents (accordion titles,
      // buttons) separate nodes would become separate items and lose their spaces.
      const frag = document.createElement('span');
      frag.className = 'kv-lcw';
      let last = 0;
      node.nodeValue.replace(RE, (match, index) => {
        if (index > last) frag.append(node.nodeValue.slice(last, index));
        const span = document.createElement('span');
        span.className = 'kv-lc';
        span.textContent = 'kava';
        frag.append(span);
        last = index + match.length;
      });
      if (last < node.nodeValue.length) frag.append(node.nodeValue.slice(last));
      node.replaceWith(frag);
    }
  };

  const run = () => {
    fix(document.body);
    if (document.title) document.title = document.title.replace(RE, 'kava');
    // Cart drawer, quick add and apps render later — batch their updates.
    let queued = new Set();
    let scheduled = false;
    new MutationObserver((records) => {
      for (const r of records) for (const n of r.addedNodes) if (n.nodeType === 1) queued.add(n);
      if (!scheduled && queued.size) {
        scheduled = true;
        requestAnimationFrame(() => {
          queued.forEach((n) => n.isConnected && fix(n));
          queued = new Set();
          scheduled = false;
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
